import JSONViewer from './components/JSONViewer';

function App() {
  return (
    <div className="h-full flex flex-col">
      <header className="flex items-center justify-center gap-3 py-4 px-4 bg-editor-dark border-b border-editor-border shrink-0">
        <img 
          src="https://coderomeos.org/storage/uploads/images/settings-site-logo-5a59026ae4322.png" 
          alt="CodeRomeos Logo" 
          className="h-6 sm:h-8 w-auto"
        />
        <h1 className="text-xl sm:text-2xl font-bold text-editor-text">JSON Viewer & Formatter</h1>
      </header>
      <main className="flex-1 overflow-hidden">
        <JSONViewer />
      </main>
    </div>
  );
}

export default App;
